import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

const ExploreWidgetsBanner = () => {
  const { t } = useTranslation("coaching-portal");

  return (
    <div className="explore-widgets-banner flex items-center justify-between gap-4 rounded-xl p-4">
      <div className="flex items-center gap-4">
        <div className="rounded-xl bg-(--white-05) p-2">
          <SvgIcon
            src="/img/new-icons/question-circle-solid.svg"
            noFilterOnLight
          />
        </div>
        <div>
          <p className="text-lg font-semibold">
            {t("allTemplates.chooseASection.doYouKnow.title")}
          </p>
          <p className="p4 opacity-70 pt-1">
            {t("allTemplates.chooseASection.doYouKnow.description")}
          </p>
        </div>
      </div>
      <a role="button" //NOSONAR
       data-button-type="outline" href="/coaching-portal/widgets">
        <span>{t("allTemplates.chooseASection.doYouKnow.exploreWidgets")}</span>
      </a>
    </div>
  );
};

export default ExploreWidgetsBanner;
